import {ContainerBinder} from '../../../../../IoC/ContainerBinder';
import {TrackersStore} from '../../stores/Trackers/Trackers.store';
import {CreateDiaryEntryUseCase} from '../../useCases/CreateDiaryEntry.uc';
import {DeleteDiaryEntryUseCase} from '../../useCases/DeleteDiaryEntry.uc';
import {FetchMetricsUseCase} from '../../useCases/FetchMetrics.uc';
import {ListDiaryEntriesUseCase} from '../../useCases/ListDiaryEntries.uc';
import {TrackWeightUseCase} from '../../useCases/TrackWeight.uc';

export const trackersBindDomain = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container).done();
};

export const trackersBindUseCases = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(FetchMetricsUseCase)
    .bindSingleton(TrackWeightUseCase)
    .bindSingleton(CreateDiaryEntryUseCase)
    .bindSingleton(ListDiaryEntriesUseCase)
    .bindSingleton(DeleteDiaryEntryUseCase)
    .done();
};

export const trackersBindStores = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container).bind(TrackersStore).done();
};
